<template>
  <Modal
    class="gameplay"
    @close="toggleModal('gameplay')"
    v-if="modals.gameplay && roles.size"
  >
    <font-awesome-icon
      @click="toggleModal('rule')"
      icon="balance-scale"
      class="toggle"
      title="Regel-Merkblatt anzeigen"
    />
    <h3>
      Spielablauf-Merkblatt
      <font-awesome-icon icon="balance-scale" />
    </h3>

    <dl>
        <dt>ALLGEMEIN</dt>
        <dd>
            • <u>In der Nacht</u> weckt die Spielleitung nacheinander alle auf, die wegen ihrer oder einer anderen Fähigkeit erwachen (siehe Nacht-Merkblatt).
        </dd>
        <dd>
            • <u>Am Tag</u> können alle miteinander reden und sich dazu auch in private Räume zurückziehen.
        </dd>
        <dd>
            • Der Dorfplatz gilt als öffentlicher Raum, an dem alle kommen und gehen können, wie sie wollen.
        </dd>
        <dd>
            • Jegliche Kommunikation muss im Gespräch erfolgen, es dürfen keine privaten Textchats genutzt werden.
        </dd>
        <dd>
            • Es ist nicht erlaubt, ungebeten private Räume zu betreten.
        </dd>
        <dd>
            • Über die Funktion „anstupsen“ auf Teamspeak (Rechtsklick auf gewünschte Person) kannst du jedoch andere wissen lassen, dass du mit Ihnen ein Gespräch führen möchtest.
        </dd>
        <dd>
            • Nach einer gewissen Zeit ruft die Spielleitung alle auf den Dorfplatz zurück, um die Nominierungen über die Hinrichtung zu starten.
        </dd>
        <dd>
            • <u>Nach einer Exekution wird der Tag beendet</u>, auch wenn diese zum Beispiel durch die Jungfrau ausgelöst wird!
            Hiernach beginnt die nächste Nacht.
        </dd>
        <dd>
            • Das Spiel läuft so lange weiter, bis eine der Win Conditions (siehe Regel-Merkblatt) eingetreten ist.
        </dd>
        <br />
        <dt>NOMINIERUNGEN</dt>
        <dd>
            • <u>Während der Nominierungsphase</u> kann in der Gruppe diskutiert werden.
        </dd>
        <dd>
            • Die Spielleitung macht drei Aufrufe zur Abstimmung.
        </dd>
        <dd>
            • Einige Sekunden nach dem dritten Aufruf wird der Tag beendet, auch wenn keine Hinrichtung passiert ist.
        </dd>
        <dd>
            • <u>Pro Tag</u> können alle Lebenden einmal nominieren und einmal nominiert werden.
        </dd>
        <dd>
            • Sobald der Satz <u>„Ich nominiere XY“</u> geäußert wird, wird die Diskussion unterbrochen.
            Die Anklage kann ihren Standpunkt vortragen, anschließend die Verteidigung.
            Andere können ihre Kommentare dazu abgeben, bevor abgestimmt wird.
        </dd>
        <dd>
            • Zur Abstimmung muss die Hälfte (oder mehr) der Summe lebender Spieler*innen für die Hinrichtung stimmen.
            Dann ist die nominierte Person zur Hinrichtung markiert.
        </dd>
        <dd>
            • Wenn anschließend für eine andere Person mehr Stimmen zusammenkommen, ist stattdessen diese markiert.
        </dd>
        <dd>
            • Erhält eine andere Person gleich viele Stimme, wird die Markierung für beide aufgehoben.
        </dd>
        <dd>
            • <u>Tote</u> können nur noch genau einmal im Spiel abstimmen.
        </dd>
    </dl>

  </Modal>
</template>

<script>
import Modal from "./Modal";
import { mapMutations, mapState } from "vuex";

export default {
  components: {
    Modal
  },
  computed: {
    /**
     * Return a list of jinxes in the form of role IDs and a reason
     * @returns {*[]} [{first, second, reason}]
     */
    jinxed: function() {
      const jinxed = [];
      this.roles.forEach(role => {
        if (this.jinxes.get(role.id)) {
          this.jinxes.get(role.id).forEach((reason, second) => {
            if (this.roles.get(second)) {
              jinxed.push({
                first: role,
                second: this.roles.get(second),
                reason
              });
            }
          });
        }
      });
      return jinxed;
    },
    rolesGrouped: function() {
      const rolesGrouped = {};
      this.roles.forEach(role => {
        if (!rolesGrouped[role.team]) {
          rolesGrouped[role.team] = [];
        }
        rolesGrouped[role.team].push(role);
      });
      delete rolesGrouped["traveler"];
      return rolesGrouped;
    },
    playersByRole: function() {
      const players = {};
      this.players.forEach(({ name, role }) => {
        if (role && role.id && role.team !== "traveler") {
          if (!players[role.id]) {
            players[role.id] = [];
          }
          players[role.id].push(name);
        }
      });
      return players;
    },
    ...mapState(["roles", "modals", "edition", "grimoire", "jinxes"]),
    ...mapState("players", ["players"])
  },
  methods: {
    ...mapMutations(["toggleModal"])
  }
};
</script>

<style lang="scss" scoped>
@import "../../vars.scss";

.toggle {
  position: absolute;
  left: 20px;
  top: 15px;
  cursor: pointer;
  &:hover {
    color: red;
  }
}

.togglesecond {
  position: absolute;
  left: 50px;
  top: 15px;
  cursor: pointer;
  &:hover {
    color: red;
  }
}

h3 {
  margin: 0 40px;
  svg {
    vertical-align: middle;
  }
}

.townsfolk {
  .name {
    color: $townsfolk;
  }
  aside {
    background: linear-gradient(-90deg, $townsfolk, transparent);
  }
}
.outsider {
  .name {
    color: $outsider;
  }
  aside {
    background: linear-gradient(-90deg, $outsider, transparent);
  }
}
.minion {
  .name {
    color: $minion;
  }
  aside {
    background: linear-gradient(-90deg, $minion, transparent);
  }
}
.demon {
  .name {
    color: $demon;
  }
  aside {
    background: linear-gradient(-90deg, $demon, transparent);
  }
}

.jinxed {
  .name {
    color: $fabled;
  }
  aside {
    background: linear-gradient(-90deg, $fabled, transparent);
  }
}

.team {
  display: flex;
  align-items: stretch;
  width: 100%;
  &:not(:last-child):after {
    content: " ";
    display: block;
    width: 25%;
    height: 1px;
    background: linear-gradient(90deg, #ffffffaa, transparent);
    position: absolute;
    left: 0;
    bottom: 0;
  }
  aside {
    width: 30px;
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    align-content: center;
    overflow: hidden;
    text-shadow: 0 0 4px black;
  }

  h4 {
    text-transform: uppercase;
    text-align: center;
    transform: rotate(90deg);
    transform-origin: center;
    font-size: 80%;
  }

  &.jinxed {
    .icon {
      margin: 0 -5px;
    }
  }
}

ul {
  flex-grow: 1;
  display: flex;
  padding: 5px 0;

  li {
    display: flex;
    align-items: center;
    flex-grow: 1;
    width: 420px;
    .icon {
      width: 8vh;
      background-size: cover;
      background-position: 0 -5px;
      flex-shrink: 0;
      flex-grow: 0;
      &:after {
        content: " ";
        display: block;
        padding-top: 75%;
      }
    }
    .role {
      line-height: 80%;
      flex-grow: 1;
    }
    .name {
      font-weight: bold;
      font-size: 75%;
      display: block;
    }
    .player {
      color: #888;
      float: right;
      font-size: 60%;
    }
    .ability {
      font-size: 70%;
    }
  }
}

/** break into 1 column below 1200px **/
@media screen and (max-width: 1199.98px) {
  .modal {
    max-width: 60%;
  }
  ul {
    li {
      .icon {
        width: 6vh;
      }
      .role {
        line-height: 100%;
      }
      .name {
        font-size: 100%;
      }
      .player {
        font-size: 100%;
      }
      .ability {
        font-size: 90%;
      }
    }
  }
}

/** trim icon size on maximized one-column sheet **/
@media screen and (max-width: 991.98px) {
  .gameplay .modal.maximized ul li .icon {
    width: 5.1vh;
  }
}

/** hide players when town square is set to "public" **/
#townsquare.public ~ .gameplay .modal .player {
  display: none;
}
</style>
